<template>
  <div class="content-box">
    <h2>{{$t('agreementTitle')}}</h2>
    <p class="little-title">{{ $t('comfirm') }}</p>
    <p class="clearfix"></p>
    
    <p>{{ $t('comfirmDes') }}</p>

    <p class="little-title">{{ $t('ownerShip') }}</p>
    <p>{{ $t('ownerShipDes') }}</P>

    <p class="little-title">{{ $t('serviceContent') }}</p>
    <p>{{ $t('serviceContent1') }}</P>
    <p>{{ $t('serviceContent2') }}</P>
    <p>{{ $t('serviceContent3') }}</P>

    <p class="little-title">{{ $t('serviceDesTitle') }}</p>
    <p v-for="(des, index) in $t('serviceDes')" :key='index'>
      {{ des }}
    </p>

    <p class="little-title">{{ $t('openService') }}</p>
    <p v-for="(des, index) in $t('openServiceDes')" :key='index'>
      {{ des }}
    </p>

    <p class="little-title">{{ $t('validityPeriod') }}</p>
    <p v-for="(des, index) in $t('validityPeriodDes')" :key='index'>
      {{ des }}
    </p>

    <p class="little-title">{{ $t('unsubscribe') }}</p>
    <p v-for="(des, index) in $t('unsubscribeDes')" :key='index'>
      {{ des }}
    </p>

    <p class="little-title">{{ $t('agreementPeriod') }}</p>
    <p>{{ $t('agreementPeriodDes') }}</P>
  </div>
</template>

<script>
  import locales from './lang'
  export default {
    name: 'automatic-renewal-agreement',
    locales
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  * {
    padding: 0;
    margin: 0;
  }

  .content-box {
    max-width: 1180px;
    margin: .5rem auto;
    padding: .4rem;
    text-align: left;
    @media (max-width: 767px) {
      padding: .4rem .2rem;
      margin: 0 auto;
    }
  }
  p{
    font-size: .14rem;
    color: #333333;
    letter-spacing: 0;
    line-height: .3rem;
  }
  .little-title {
    font-size: .2rem;
    color: #333333;
    letter-spacing: 0;
    margin-bottom: .2rem;
    margin-top: .6rem;
    line-height: .24rem;
    &:first-child {
      margin-top: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// AutoRenewalAgreement.vue?10bea012